import { render, staticRenderFns } from "./LoginMagicNumber.vue?vue&type=template&id=deeced74&"
import script from "./LoginMagicNumber.vue?vue&type=script&lang=js&"
export * from "./LoginMagicNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports